/* eslint-disable prettier/prettier */
/* eslint-disable no-param-reassign */
/* eslint-disable react/no-string-refs */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/extensions */
import "./loadingOverlay.css";
import "react-placeholder/lib/reactPlaceholder.css";
import React, { useState, useCallback, useEffect } from "react";
import styled, { css } from "styled-components";
import { useTranslation } from 'react-i18next';
import { drawDOM, exportPDF } from "@progress/kendo-drawing";
import axios from "axios";
import Checkbox from "@material-ui/core/Checkbox";
import GameSummaryLabels from "./GameSummaryLabels";
import ReportCard from "./ReportCard";

import {
  DiamondSm,
  DownArrow,
  X,
  EmojiSerriousSmiley,
  EmojiHappySmiley,
  EmojiUnhappySmiley,
} from "../../Constants/assets";
import fetchConfig from "../../Constants/fetch";

// const BackgroundContainer = styled.div`
//     width: 100vw;
//     // height: 100vh;
//     // position: absolute;
//     // background-color: rgb(43, 43, 50, 0.8) !important;
// `;
const PopUpContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;
`;
const InnerContainer = styled.div`
  box-shadow: 0px 4px 60px 4px rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  position: relative;
  z-index: 1;
  width: 70rem;
  height: auto;
  background-color: white;
  overflow-y: scroll;
  overflow-x: hidden;
`;
const TotalGradeContainer = styled.div`
  box-shadow: 0px 4px 60px 4px rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  position: absolute;
  z-index: 0;
  width: 45%;
  height: 64.5vh;
  background-color: white;
`;
const SummaryDescription = styled.div`
  color: ${(props) => props.theme.colors.gray};
`;
const ContentArea = styled.div`
  width: 100%;
  margin: 32px auto;
  height: auto;
  width: 93%;
`;

const HeaderContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  height: 9%;
`;
const HeaderTitle = styled.div`
  font-size: 24px;
  font-weight: bold;
`;
const SubTitle = styled.div`
  font-size: 20px;
  font-weight: 400;
`;
const XContainer = styled.div``;

const ColumnContainer = styled.div`
  height: 1.5rem;
`;
const Title = styled.div`
  font-size: 12px;
  color: ${(props) => props.theme.colors.gray};
  width: 30%;
`;

const WatermarkOuter = styled.div`
  width: 100%;
  height: 107vh;
  border-radius: 8px;
  /* display: flex;
    justify-content: center;
    align-items: center; */
  position: absolute;
  overflow: hidden;
  top: -7vh;
  margin-left: -1.7vw;
  z-index: -1;
  white-space: nowrap;
`;

const Watermark = styled.div`
  font-size: 30px;
  font-weight: 200;
  transform: rotate(-10deg);
  color: rgb(0 0 0 / 5%);
  position: absolute;
  left: -4vw;
  top: -7vh;
  width: 100vw;
  height: 120vh;
  overflow-y: hidden;
`;
const Table = styled.table`
  width: 100%;
  height: 100%;
  border: 1px solid black;
  border-collapse: collapse;
`;
const Td = styled.td`
  border: 1px solid black;
  border-collapse: collapse;
`;
const Th = styled.th`
  border: 1px solid black;
  border-collapse: collapse;
  width: 2vw;
`;

const ColumnDiv = styled.div`
  display: flex;
  height: 1.9rem;
`;
const AarSection = styled.section`
  margin-top: 40px;
`;
const AarSectionTitle = styled.div`
  font-size: 24px;
`;
const AarSectionSubtitle = styled.div`
  color: ${(props) => props.theme.colors.gray};
  font-size: 16px;
  margin-top: 4px;
`;
const AarColumns = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
  margin-top: 16px;
`;
const AarColumn = styled.div`
  border: 1px solid #e5e2dc;
  border-radius: 8px;
  padding: 16px 20px;
`;
const AarColumnTitle = styled.div`
  font-size: 24px;
`;
const AarColumnSubtitle = styled.div`
  color: ${(props) => props.theme.colors.gray};
  font-size: 16px;
  margin-top: 4px;
`;
const AarMetrics = styled.div`
  margin-top: 14px;
`;
const AarPreviousMetric = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #eeeae4;
`;
const AarPreviousChoice = styled.button`
  border: 1px solid ${(props) => (props.$selected ? "#347a63" : "#ccc8c1")};
  border-radius: 18px;
  background: ${(props) => (props.$selected ? "#347a63" : "white")};
  color: ${(props) => (props.$selected ? "white" : "#666")};
  padding: 6px 16px;
  font-size: 16px;
  opacity: 1;
`;
const ActionButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin: 32px 0;
`;
const ActionButton = styled.button`
  min-height: 44px;
  padding: 0 20px;
  border: 1px solid ${(props) => props.theme.colors.darkGreen};
  border-radius: 4px;
  background: ${(props) => (props.$primary ? props.theme.colors.darkGreen : "white")};
  color: ${(props) => (props.$primary ? "white" : props.theme.colors.darkGreen)};
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
const AarMetric = styled.label`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  padding: 8px 0;
  border-bottom: 1px solid #eeeae4;
  color: ${(props) => (props.disabled ? "#bdbdbd" : "inherit")};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
`;

let pdfHasSaved = false;
let pdfHasStartedSaving = false;
export default function SummaryPopUp({
  projectId,
  setPopUp,
  shortReport,
  logSideBar,
  shortSummaryPdf,
  pdfFile,
  isItAPreviousReport,
  playerEmail,
  newData,
  showLabels,
  gameStartDateTime,
  gameStartDateTimeString,
  userId,
  restartGameFunction,
  playerName,
  email,
  logout,
}) {

  const { t } = useTranslation();
  const [aarMetrics, setAarMetrics] = useState([]);
  const [previousAarMetrics, setPreviousAarMetrics] = useState([]);
  const [selectedAarMetrics, setSelectedAarMetrics] = useState({
    keep: [],
    improve: [],
  });

  useEffect(() => {
    let isMounted = true;

    axios
      .get(`${fetchConfig.prefix}/game/aar_metrics`, {
        params: { userId },
      })
      .then(({ data }) => {
        if (isMounted) setAarMetrics(data);
      })
      .catch((error) => console.error("Failed to fetch AAR metrics", error));

    return () => {
      isMounted = false;
    };
  }, [userId]);

  useEffect(() => {
    if (!newData?.gameId || !userId) return undefined;

    let isMounted = true;
    axios
      .get(`${fetchConfig.prefix}/game/previous_aar_metrics`, {
        params: { gameId: newData.gameId, userId },
      })
      .then(({ data }) => {
        if (isMounted) setPreviousAarMetrics(data);
      })
      .catch((error) => console.error("Failed to fetch previous AAR metrics", error));

    return () => {
      isMounted = false;
    };
  }, [newData?.gameId, userId]);

  const saveAarMetricSelection = async (aarMetricId, type, checked, value = null) => {
    try {
      await axios.post(`${fetchConfig.prefix}/game/aar_metrics_selection`, {
        gameId: newData?.gameId,
        userId,
        aarMetricId,
        type,
        value,
        checked,
      });
    } catch (error) {
      console.error("Failed to save AAR metric selection", error);
    }
  };

  const disableAarAndLogout = async () => {
    try {
      await axios.post(`${fetchConfig.prefix}/game/disable_aar`, { userId });
      logout();
    } catch (error) {
      console.error("Failed to disable AAR", error);
    }
  };

  const renderPreviousAarMetrics = (side) => {
    return previousAarMetrics
      .filter((metric) => metric.type === side)
      .map(({ aarMetricId, description, value }) => (
        <AarPreviousMetric key={`${side}-${aarMetricId}`}>
          <span style={{ flex: 1 }}>{description}</span>
          {["yes", "partly", "no"].map((option) => (
            <AarPreviousChoice
              key={option}
              type="button"
              $selected={value === option}
              aria-pressed={value === option}
              aria-label={`${description}: ${t(`report.summary_stats.aar_${option}`)}`}
              onClick={() => {
                setPreviousAarMetrics((previous) =>
                  previous.map((metric) =>
                    metric.aarMetricId === aarMetricId && metric.type === side
                      ? { ...metric, value: option }
                      : metric,
                  ),
                );
                saveAarMetricSelection(aarMetricId, "self check", true, option);
              }}
            >
              {t(`report.summary_stats.aar_${option}`)}
            </AarPreviousChoice>
          ))}
        </AarPreviousMetric>
      ));
  };

  const renderAarMetrics = (side) => {
    const selected = selectedAarMetrics[side];
    const oppositeSide = side === "keep" ? "improve" : "keep";

    return aarMetrics.map(({ id, metricKey, description }) => {
      const checked = selected.includes(id);
      const disabled = selectedAarMetrics[oppositeSide].includes(id);

      return (
        <AarMetric
          key={`${side}-${id}`}
          htmlFor={`aar-metric-${side}-${id}`}
          disabled={disabled}
        >
          <Checkbox
            id={`aar-metric-${side}-${id}`}
            checked={checked}
            disabled={disabled}
            inputProps={{ "aria-label": description }}
            onChange={(_, isChecked) => {
              if (isChecked && selected.length >= 3) return;

              const nextSelected = isChecked
                ? [...selected, id]
                : selected.filter((selectedId) => selectedId !== id);

              setSelectedAarMetrics((previous) => ({
                ...previous,
                [side]: nextSelected,
              }));
              saveAarMetricSelection(id, side, isChecked);
            }}
            style={{ padding: 0 }}
          />
          <span>{description}</span>
        </AarMetric>
      );
    });
  };

  const saveAsPdf = () => {
    if (!pdfHasSaved) {
      setTimeout(() => {
        pdfHasStartedSaving = true;  // for the X button to be clickable
        const element = document.getElementById("main-container");
        // const element = document.body;
        drawDOM(element, {
          // paperSize: 'A4',
          landscape: false,
          multiPage: true,
          forcePageBreak: true,
          scale: 0.5,
        })
          .then((group) => {
            pdfHasSaved = true;
            return exportPDF(group);
          })
          .then((dataUri) => {
            pdfFile = dataUri;
          })
          .then(() => {
            shortSummaryPdf(pdfFile);
          });
      }, 500);
    }
  };

  const styles = {
    popup: {
      width: "95vw",
      height: isItAPreviousReport ? "" : "100vh",
      position: isItAPreviousReport ? "" : "absolute",
      backgroundColor: isItAPreviousReport
        ? ""
        : "rgb(43, 43, 50, 0.8) !important",
    },
  };

  const watermarkLineLength = `${playerEmail} ${gameStartDateTimeString} `.length;
  const loopLength = Math.floor(3200 / watermarkLineLength);
  const repeatWaterMarkLine = 5
  const array = Array.from({ length: loopLength }, (_, i) => (
    <React.Fragment key={i}>
      {`${playerEmail} ${gameStartDateTimeString} `.repeat(repeatWaterMarkLine)}
      <br />
    </React.Fragment>
  ));
  console.log(newData);
  if (newData !== undefined && shortReport !== undefined && showLabels) {
    const completion = newData.projectScopeCompletionPercentage;
    const summaryReport = newData;
    const isCompletedGame = !newData.projectCanceled && !newData.playerQuit;
    return (
      <div style={styles.popup} className="summeryWrapComp">
        <PopUpContainer id="main-container">
          <InnerContainer>
            <ContentArea>
            <HeaderContainer>
              <HeaderTitle>{t(`report.summary_stats.summary_stats_title`)}</HeaderTitle>
              <XContainer>
                <X
                  style={{
                    cursor: pdfHasStartedSaving ? "pointer" : "auto",
                  }}
                  onClick={() => {
                    console.log("pdf has saved", pdfHasStartedSaving);
                    if (pdfHasStartedSaving) {
                      setPopUp(false);
                    }
                  }}
                />
              </XContainer>
            </HeaderContainer>
            </ContentArea>
            <ContentArea>
              <ReportCard summaryReport={summaryReport} t={t} />
            </ContentArea>
            <ContentArea>
              <SummaryDescription>{t(`global_variables.projects.${projectId}.project_objective`, { projectId })}</SummaryDescription>
              <WatermarkOuter>
                <Watermark>{array}</Watermark>
              </WatermarkOuter>
              <div style={{ display: "flex", height: "4%" }}>
                <ColumnContainer
                  style={{
                    width: "45%",
                  }}
                />
              </div>

              <GameSummaryLabels
                logSideBar={logSideBar}
                newData={newData}
                isItAPreviousReport={isItAPreviousReport}
                completion={completion}
                projectCanceled={newData.projectCanceled}
                playerQuit={newData.playerQuit}
                gameStartDateTime={gameStartDateTime}
              />
              {isCompletedGame && aarMetrics.length > 0 && (
                <AarSection>
                  {previousAarMetrics.length > 0 && (
                    <>
                      <AarSectionTitle>
                        {t("report.summary_stats.aar_previous_section_title")}
                      </AarSectionTitle>
                      <AarSectionSubtitle>
                        {t("report.summary_stats.aar_previous_section_subtitle")}
                      </AarSectionSubtitle>
                      <AarColumns>
                        <AarColumn>
                          <AarColumnTitle>
                            {t("report.summary_stats.aar_previous_keep_title")}
                          </AarColumnTitle>
                          <AarColumnSubtitle>
                            {t("report.summary_stats.aar_previous_keep_subtitle")}
                          </AarColumnSubtitle>
                          <AarMetrics>{renderPreviousAarMetrics("keep")}</AarMetrics>
                        </AarColumn>
                        <AarColumn>
                          <AarColumnTitle>
                            {t("report.summary_stats.aar_previous_improve_title")}
                          </AarColumnTitle>
                          <AarColumnSubtitle>
                            {t("report.summary_stats.aar_previous_improve_subtitle")}
                          </AarColumnSubtitle>
                          <AarMetrics>{renderPreviousAarMetrics("improve")}</AarMetrics>
                        </AarColumn>
                      </AarColumns>
                    </>
                  )}
                  <AarSectionTitle style={{ marginTop: previousAarMetrics.length ? 40 : 0 }}>
                    {t("report.summary_stats.aar_section_title")}
                  </AarSectionTitle>
                  <AarSectionSubtitle>
                    {t("report.summary_stats.aar_section_subtitle")}
                  </AarSectionSubtitle>
                  <AarColumns>
                    <AarColumn>
                      <AarColumnTitle>
                        {t("report.summary_stats.aar_keep_title")}
                      </AarColumnTitle>
                      <AarColumnSubtitle>
                        {t("report.summary_stats.aar_keep_subtitle")}
                      </AarColumnSubtitle>
                      <AarMetrics>{renderAarMetrics("keep")}</AarMetrics>
                    </AarColumn>
                    <AarColumn>
                      <AarColumnTitle>
                        {t("report.summary_stats.aar_improve_title")}
                      </AarColumnTitle>
                      <AarColumnSubtitle>
                        {t("report.summary_stats.aar_improve_subtitle")}
                      </AarColumnSubtitle>
                      <AarMetrics>{renderAarMetrics("improve")}</AarMetrics>
                    </AarColumn>
                  </AarColumns>
                </AarSection>
              )}
              {saveAsPdf()}
              {isCompletedGame && !isItAPreviousReport && aarMetrics.length > 0 && (
                <ActionButtons>
                  <ActionButton
                    type="button"
                    disabled={selectedAarMetrics.keep.length > 0 || selectedAarMetrics.improve.length > 0}
                    onClick={disableAarAndLogout}
                  >
                    I'm good, Nothing to Improve
                  </ActionButton>
                  <ActionButton
                    type="button"
                    $primary
                    disabled={!selectedAarMetrics.keep.length || !selectedAarMetrics.improve.length}
                    onClick={() => restartGameFunction(playerName, email)}
                  >
                    Play Again
                  </ActionButton>
                </ActionButtons>
              )}
            </ContentArea>
          </InnerContainer>
        </PopUpContainer>
      </div>
    );
  }
  return (
    <div style={styles.popup}>
      <PopUpContainer id="main-container">
        <InnerContainer>
          <ContentArea>
            <HeaderContainer>
              <HeaderTitle>{t(`report.summary_stats.summary_stats_title`)}</HeaderTitle>
              <XContainer>
                <X
                  style={{
                    cursor: pdfHasStartedSaving ? "pointer" : "auto",  // eslint-disable-line
                  }}
                  onClick={() => {
                    console.log("pdf has saved", pdfHasStartedSaving);
                    if (pdfHasStartedSaving) {
                      setPopUp(false);
                    }
                  }}
                />
              </XContainer>
            </HeaderContainer>
            <WatermarkOuter>
              <Watermark>{array}</Watermark>
            </WatermarkOuter>
            <div style={{ display: "flex", height: "4%" }}>
              <ColumnContainer
                style={{
                  width: "45%",
                }}
              />
            </div>

            <div className="spinner">
              <div className="bounce1" />
              <div className="bounce2" />
              <div className="bounce3" />
            </div>
          </ContentArea>
        </InnerContainer>
      </PopUpContainer>
    </div>
  );
}
